<template>
  <header class="btn-toolbar d-block" role="toolbar" aria-label="Gestió projecte en seguiment" :class="esVistaSimplificada ? 'text-nowrap ml-2' : 'mb-1 mr-2'" :disabled="loading.proyectosGestion[index] || loading.orden">
    <div class="btn-group btn-group-toggle btn-group-sm" :class="{ 'mr-2 mt-1': !esVistaSimplificada, 'mr-2': esVistaSimplificada }" data-toggle="buttons">
      <label class="btn btn-outline-secondary" :class="{ disabled: loading.proyectosGestion[index] || loading.orden, active: !item.filtre }">
        <input type="radio" name="options" value="" v-model="item.filtre" @change="$emit('cambiarFiltro', item, index)" />
        Tot
      </label>
      <label class="btn btn-outline-secondary" :class="{ disabled: loading.proyectosGestion[index] || loading.orden, active: item.filtre == 'LTM' }" title="Últims 12 mesos" v-tooltip>
        <input type="radio" name="options" value="LTM" v-model="item.filtre" @change="$emit('cambiarFiltro', item, index)" />
        LTM
      </label>
      <label class="btn btn-outline-secondary" :class="{ disabled: loading.proyectosGestion[index] || loading.orden, active: item.filtre == 'YTD' }" title="Enguany" v-tooltip>
        <input type="radio" name="options" value="YTD" v-model="item.filtre" @change="$emit('cambiarFiltro', item, index)" />
        YTD
      </label>
    </div>
    <slot></slot>
  </header>
</template>

<script>
export default {
  name: 'BtnFiltroProyecto',
  props: {
    item: {
      type: Object,
      required: true,
    },
    index: {
      type: Number,
      required: true,
    },
    loading: {
      type: Object,
      required: true,
    },
    esVistaSimplificada: {
      type: Boolean,
      default: false,
    },
  },
};
</script>
